import React, { useMemo } from "react";
import { ServerPaginatedtable } from "../../../shared";
import { useCostChangeHistory } from "../hooks";
import { formatCost } from "../../../utils";

export const CostChangeHistory = () => {
  const { tableState, moduleName, tableHelpers, costChangeHistoryQuery } =
    useCostChangeHistory();

  // Extract pagination info from the list query
  const apiPagination = costChangeHistoryQuery?.data?.pagination ?? {
    total: 0,
    lastPage: 1,
  };

  const columns = useMemo(
    () => [
      {
        header: "Date & Time",
        accessorKey: "date",
      },
      {
        header: "User",
        accessorKey: "changed_by",
      },
      {
        header: "Buying Unit",
        accessorKey: "buying_unit",
      },
      {
        header: "Old Cost(ex GST)",
        accessorKey: "old_cost_exc_gst",
        cell: ({ getValue }) => `$${formatCost(getValue())}`,
      },
      {
        header: "New Cost(ex GST)",
        accessorKey: "new_cost_exc_gst",
        cell: ({ getValue }) => `$${formatCost(getValue())}`,
      },
    ],
    [],
  );

  return (
    <ServerPaginatedtable
      columns={columns}
      defaultData={costChangeHistoryQuery?.data?.history || []}
      tableId="costChangeHistory"
      headerText="Cost Change History"
      isInTab
      isLoading={costChangeHistoryQuery.isLoading}
      pagination={tableState.pagination}
      setPagination={(callback) =>
        tableHelpers.setPagination({ tableName: moduleName, callback })
      }
      paginationProps={apiPagination}
      search={tableState.search}
      onSearchChange={tableHelpers.onSearchHandler}
      sorting={tableState.sorting}
      setSorting={(callback) =>
        tableHelpers.setSorting({ tableName: moduleName, callback })
      }
      rightContent={<span></span>}
    />
  );
};
